module.exports = __webpack_public_path__ + "img/inventory_outlined.bf7b6d91.svg";